import { useEffect } from 'react';

export const useHeightAsCssVariable = (cssVar: string, node: HTMLElement | null) => {
    useEffect(() => {
        if (!node) {
            return;
        }

        let height: number | null = null;

        const observer = new ResizeObserver(entries => {
            const { height: newHeight } = entries[0].contentRect;

            if (newHeight !== height) {
                height = newHeight;
                document.body.style.setProperty(cssVar, height + 'px');
            }
        });

        observer.observe(node);

        return () => {
            observer.disconnect();
            document.body.style.removeProperty(cssVar);
        };
    }, [node, cssVar]);
};
